var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.26 38.3345L100.685 40.9097",
    stroke: "#02BF8E",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.248 47.3447L91.6728 49.9199",
    stroke: "#02BF8E",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.26 49.9258L100.685 47.3506",
    stroke: "#02BF8E",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.248 40.9126L91.6728 38.3374",
    stroke: "#02BF8E",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 84.9998V68.3332C45 64.6513 47.9848 61.6665 51.6667 61.6665H65.8798C68.4049 61.6665 70.7133 63.0932 71.8426 65.3517L73.1574 67.9813C74.2867 70.2398 76.5951 71.6665 79.1202 71.6665H103.333C107.015 71.6665 110 74.6513 110 78.3332V81.6665M45 93.1665V115C45 118.682 47.9848 121.667 51.6667 121.667H107.545C110.556 121.667 113.193 119.648 113.98 116.741L119.392 96.7411C120.538 92.5032 117.347 88.3332 112.956 88.3332H64.9013C61.9854 88.3332 59.4078 90.2282 58.5381 93.0113L51.6667 115",
    stroke: "#02BF8E",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.084,
    cy: 30.4046,
    r: 3.33333,
    transform: "rotate(45 67.084 30.4046)",
    stroke: "#02BF8E",
    strokeWidth: 3.33333
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.416,
    cy: 82.0711,
    r: 3.33333,
    transform: "rotate(45 140.416 82.0711)",
    stroke: "#02BF8E",
    strokeWidth: 3.33333
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.75,
    cy: 63.7376,
    r: 3.33333,
    transform: "rotate(45 28.75 63.7376)",
    stroke: "#02BF8E",
    strokeWidth: 3.33333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.0e011fa7.svg";
export { ForwardRef as ReactComponent };